




























































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsBreakdown from "@/design-system/patterns/Breakdown/JdsBreakdown.vue"
import JdsBreakdownItem from "@/design-system/patterns/Breakdown/JdsBreakdownItem.vue"
import JdsMoney from "@/design-system/components/Money/JdsMoney.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsBreakdownHeading from "@/design-system/patterns/Breakdown/JdsBreakdownHeading.vue"
@Component({
    components: {
        JdsBreakdownHeading,
        JdiDocs, JdsButton, JdsMoney, JdsBreakdownItem, JdsBreakdown, JdiPreview, JdiContent}
})
export default class Breakdown extends Vue {
    loader2 = false
    loader3 = false
    randomEvents = 0
    clicked = false

    load2(){
        this.loader2 = true
        setTimeout(() =>{
            this.loader2 = false
        }, 3000)
    }

    load3(){
        this.loader3 = true
        setTimeout(() =>{
            this.loader3 = false
            this.randomEvents = Math.floor(Math.random()*10)
        }, 3000)
    }
}
